import { render, staticRenderFns } from "./VeranstaltungDetails.vue?vue&type=template&id=1494f8ab&scoped=true&"
import script from "./VeranstaltungDetails.vue?vue&type=script&lang=js&"
export * from "./VeranstaltungDetails.vue?vue&type=script&lang=js&"
import style0 from "./VeranstaltungDetails.vue?vue&type=style&index=0&id=1494f8ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1494f8ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VChip,VCol,VImg,VRow})
